module.exports = __webpack_public_path__ + "img/update.8b212bc6.png";